import axios from 'axios'

const url = process.env.REACT_APP_API_URL_TRANSACTION

const authConfig = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
})

class SignatureRolloutService {
    getMyPolicy() {
        return axios.get(`${url}/api/signature-policy/me`, authConfig())
    }
}

export default new SignatureRolloutService()
